import { Hidden }                                   from "@material-ui/core";
import * as React                                   from "react";
import { ReactNode }                                from "react";
import { connect }                                  from "react-redux";
import { Card }                                     from "semantic-ui-react";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import CorporationSettingButton                     from "../../components/setting/button/CorporationSettingButton";
import CustomerImportSettingButton                  from "../../components/setting/button/CustomerImportSettingButton";
import EmailSendSettingButton                       from "../../components/setting/button/EmailSendSettingButton";
import OfficeSettingButton                          from "../../components/setting/button/OfficeSettingButton";
import RecordSettingButton                          from "../../components/setting/button/RecordSettingButton";
import ReservationSettingButton                     from "../../components/setting/button/ReservationSettingButton";
import StaffAccountSettingButton                    from "../../components/setting/button/StaffAccountSettingButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

class SettingContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state: BaseState = {
      menuType: MenuType.SETTING,
      headerTitle: "設定",
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <RightPositionSection>
          <TopSection>
            <OfficeSelector/>
          </TopSection>
        </RightPositionSection>

        <Hidden smDown={ true }>
          <Card.Group itemsPerRow={ 3 }>
            <ReservationSettingButton/>
            <RecordSettingButton/>
            <EmailSendSettingButton/>
            <CustomerImportSettingButton/>
            <StaffAccountSettingButton/>
            <OfficeSettingButton/>
            <CorporationSettingButton/>
          </Card.Group>
        </Hidden>

        <Hidden mdUp={ true }>
          <Card.Group itemsPerRow={ 2 }>
            <ReservationSettingButton/>
            <RecordSettingButton/>
            <EmailSendSettingButton/>
            <CustomerImportSettingButton/>
            <StaffAccountSettingButton/>
            <OfficeSettingButton/>
            <CorporationSettingButton/>
          </Card.Group>
        </Hidden>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(SettingContainer);
